import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import moment from 'moment';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import Loader from './Loader';

const ModalPremiumDate = ({ idUser, type = "stream", onClose }) => {
    const { socket, socketSport } = useSocket()
    const matchSocket = type == "stream" ? socket : socketSport
    const userToken = infoUser()

    const [userInfo, setUserInfo] = useState(null)
    const [date, setDate] = useState("")
    const [load, setLoad] = useState(true)
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        matchSocket.emit('empire_get_user_info', { token: userToken.expecttoken, idUser }, (e) => {
            setLoad(false)
            if (e) {
                setUserInfo(e)
                setDate(e.date_premium ? moment(e.date_premium).format('YYYY-MM-DD') : "")
            }
        })
    }, [])

    const getRemaining = (d) => {
        if (!d) return null
        const target = moment(d, 'YYYY-MM-DD').endOf('day')
        const now = moment()
        if (target.isBefore(now)) return { expired: true }
        const years = target.diff(now, 'years')
        const afterYears = now.clone().add(years, 'years')
        const months = target.diff(afterYears, 'months')
        const days = target.diff(afterYears.add(months, 'months'), 'days')
        return { years, months, days }
    }
    const remaining = getRemaining(date)

    const submit = () => {
        setSaving(true)
        matchSocket.emit('empire_edit_premium_user', {
            token: userToken.expecttoken,
            idUser,
            date: date || null
        }, (ok) => {
            setSaving(false)
            if (ok) onClose(true)
        })
    }

    return (
        <div className='modal-overlay' onClick={() => onClose()}>
            <div className='modal-box' onClick={(e) => e.stopPropagation()}>
                <div className='df aic jcsb mb2'>
                    <p className='fb cw fs18'>Date Premium</p>
                    <button onClick={() => onClose()} className='pay-act-btn'><X size={18} color='#fff' /></button>
                </div>

                {load && (
                    <div className='df aic jcc py2'><Loader /></div>
                )}

                {!load && (
                    <>
                        {userInfo && (
                            <p className='fr cw fs12 mb2' style={{ opacity: 0.6 }}>ID DB : {userInfo.id_db}</p>
                        )}

                        <label className='fr cw fs12'>Date premium</label>
                        <input
                            type='date'
                            value={date}
                            onChange={(e) => setDate(e.currentTarget.value)}
                            className='premium-date-input mt1' />

                        {remaining && !remaining.expired && (
                            <div className='df gap1 mt2 premium-remaining'>
                                <div className='pr-chip'><span className='pr-num'>{remaining.years}</span><span className='pr-lbl'>an(s)</span></div>
                                <div className='pr-chip'><span className='pr-num'>{remaining.months}</span><span className='pr-lbl'>mois</span></div>
                                <div className='pr-chip'><span className='pr-num'>{remaining.days}</span><span className='pr-lbl'>jour(s)</span></div>
                            </div>
                        )}
                        {remaining && remaining.expired && (
                            <p className='fr mt2' style={{ color: '#f71717', fontSize: '0.85em' }}>Premium expiré</p>
                        )}

                        <div className='df gap1 mt2'>
                            <button onClick={() => setDate("")} className='btn cw'>Vider</button>
                            <button onClick={submit} disabled={saving} className='btn cs flex1 df aic jcc'>
                                {saving ? <span className='loader sm'></span> : "Modifier"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ModalPremiumDate;
